import React, { useEffect, useState } from 'react' 
import Main from '../../cpn/Main'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useBnsXiangMuUpdateQuery } from '../../store/BnsKeJiApi'
import { Divider } from 'antd'
import { DesktopOutlined } from '@ant-design/icons'
import ProjectEdit from './ProjectEdit'
import ClientEdit from '../client/ClientEdit'
import { useNavigateWithTags } from '../../cpn/useNavigateWithTags'

function ProjectDesc() {
    const [param] = useSearchParams()
    const eu_id = JSON.parse(localStorage.getItem('eu_id'))
    const eu_name = JSON.parse(localStorage.getItem('eu_name'))
    const navigate = useNavigate()
    const bxm_id = param.get('bxm_id')
    const {data,isSuccess} = useBnsXiangMuUpdateQuery({bxm_id:bxm_id},{skip:!bxm_id})
    const [info,setInfo] = useState({
        bxm_content:'',
        children: []
    })
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                // 按照yh_name的第一个数字进行排序
                let sorrArr = [...(data.Result.children || [])].sort((a, b) => {
                    // 提取yh_name的第一个数字
                    const getFirstNumber = (name) => {
                        const match = name.match(/\d+/);
                        return match ? parseInt(match[0]) : 0;
                    };
                    
                    const numA = getFirstNumber(a.yh_name);
                    const numB = getFirstNumber(b.yh_name);
                    
                    return numA - numB;
                });
                
                setInfo({
                    bxm_content:data.Result.bxm_content,
                    bxm_name:data.Result.bxm_name,
                    bxm_dept_id:data.Result.bxm_dept_id,
                    bxm_dept_name:data.Result.bxm_dept_name,
                    bxm_ctime:data.Result.bxm_ctime,
                    bxm_cname:data.Result.bxm_cname,
                    bxm_num:data.Result.bxm_num,
                    children: sorrArr,
                })
            }
        }
    },[data,isSuccess])

    const handleYhClick = (index) => {
        navigate(`/Userdesc?bxm_id=${bxm_id}&yh_index=${index}`)
    }
    const navi = useNavigateWithTags()
    return (
        <Main>
            <div style={{maxWidth:"1280px",backgroundColor:'#fff',padding:'20px',borderRadius:'10px'}}>
                <h1 style={{textAlign:'center'}}>{info.bxm_name}设计方案</h1>
                <div style={{textAlign:'center'}}>{info.bxm_ctime} {info.bxm_cname}</div>
                <Divider>项目说明</Divider>
                <div dangerouslySetInnerHTML={{__html:info.bxm_content}}></div>
                <ProjectEdit bxm_id={bxm_id}/>
                {/* 客户端列表部分 */}
                <Divider>客户端列表</Divider>
                <div style={{marginBottom:'20px'}}>
                    {info.children && Array.isArray(info.children) && info.children.map((item,index)=>(
                        <div 
                            key={index} 
                            style={{
                                marginBottom:'15px',
                                padding:'10px',
                                border:'1px solid #f0f0f0',
                                borderRadius:'8px',
                                transition:'all 0.3s ease'
                            }}
                        >
                            <div style={{display:'flex',alignItems:'center',marginBottom:'10px'}}>
                                <DesktopOutlined style={{marginRight:'8px'}} />
                                <span style={{fontSize:'20px',fontWeight:'bold',marginLeft:'10px'}} onClick={() => handleYhClick(index)}>{item.yh_name}</span>
                                <a 
                                    style={{marginLeft:'auto',color:'#1890ff',fontSize:'12px'}}
                                    onClick={() => {
                                        navi(`/Userdesc?yh_id=${item.yh_id}&yh_name=${item.yh_name}`,'客户端详情')
                                    }}    
                                >点击查看详情 →</a>
                                <ClientEdit 
                                    yh_id={item.yh_id}
                                    bxm_id={bxm_id}
                                    bxm_name={info.bxm_name}
                                    eu_id={eu_id}
                                    eu_name={eu_name}
                                />
                            </div>
                            <div dangerouslySetInnerHTML={{__html:item.yh_content}} style={{marginLeft:'30px',color:'#666'}}></div>
                        </div>
                    ))}
                </div>
            </div>
        </Main>
    )
}

export default ProjectDesc